<template>
  <div class="remember-device-container">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="rememberDevice"
        v-model="checked"
        @change="updateValue"
      />
      <label class="form-check-label" for="rememberDevice">
        {{ getrans("Remember this device for 30 days?") }}
      </label>
    </div>
    <div v-if="checked" class="security-notice">
      <p>{{ getrans("We’ll use a secure cookie to keep you signed in on this browser, so you don’t have to re-enter your code each time.") }}

      {{ getrans("This cookie lasts 30 days or until you clear your cookies. Don’t use this on shared devices – others could access your account.") }}

      {{ getrans("By choosing this, you agree to how we use cookies and handle your data under applicable data protection laws. [Privacy & Cookie Policy]") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RememberDeviceComponent",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    getransfn: {
      type: Function,
      required: false
    },
  },
  data() {
    return {
      checked: this.modelValue,
    };
  },
  methods: {
    getrans(key) {
      if (this.getransfn && typeof this.getransfn === 'function') {
        return this.getransfn(key);
      }
      return key; // Fallback: return the key itself if no function provided
    },
    updateValue() {
      this.$emit("update:modelValue", this.checked);
    },
  },
  watch: {
    modelValue(newVal) {
      this.checked = newVal;
    },
  },
};
</script>

<style scoped>
.remember-device-container {
  margin: 15px 0;
  display: flex;
  flex-direction: column;
}

.form-check {
  display: flex;
  align-items: center;
}

.form-check-input {
  margin-right: 8px;
}

.form-check-label {
  font-size: 1rem;
  cursor: pointer;
}

.security-notice {
  margin-top: 5px;
  color: #666;
  font-size: .8rem;
}
</style>